function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { compareLevels } from './logger';
/**
 * An implementation of Logger that logs messages to the console.
 * given a level only messages at-or above that level will be logged.
 */

export var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'debug';

    _classCallCheck(this, ConsoleLogger);

    this.level = level;
  }

  _createClass(ConsoleLogger, [{
    key: "error",
    value: function error() {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      if (compareLevels(this.level, 'warn') >= 0) {
        var _console2;

        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }, {
    key: "log",
    value: function log() {
      if (compareLevels(this.level, 'log') >= 0) {
        var _console3;

        (_console3 = console).log.apply(_console3, arguments);
      }
    }
  }, {
    key: "info",
    value: function info() {
      if (compareLevels(this.level, 'info') >= 0) {
        var _console4;

        (_console4 = console).info.apply(_console4, arguments);
      }
    }
  }, {
    key: "debug",
    value: function debug() {
      if (compareLevels(this.level, 'debug') >= 0) {
        var _console5;

        (_console5 = console).debug.apply(_console5, arguments);
      }
    }
  }]);

  return ConsoleLogger;
}();